<script setup lang="ts">
import { type PropType } from 'vue';
import ProgressSpinner from 'primevue/progressspinner';
import type { CaseNoteModel } from '@/models/caseNote';
import NoteCard from './NoteCard.vue';

defineProps({
  notes: {
    type: Array as PropType<CaseNoteModel[]>,
    required: true
  },
  loading: {
    type: Boolean,
    required: true
  }
});

const emit = defineEmits<{
  edit: [note: CaseNoteModel];
}>();
</script>

<template>
  <div class="notes-list-container">
    <div class="loading-container" v-if="loading">
      <ProgressSpinner strokeWidth="4"/>
    </div>
    <div class="empty-state" v-else-if="notes.length === 0">
      <FontAwesomeIcon :icon="['fal', 'clipboard']" class="empty-icon"/>
      <p>No notes yet.</p>
      <span>Add a note using the button above.</span>
    </div>
    <div class="notes-list" v-else>
      <NoteCard v-for="note in notes"
        :key="note.id"
        :note="note"
        @edit="emit('edit', $event)"/>
    </div>
  </div>
</template>

<style scoped lang="scss">
.notes-list-container {
  flex: 1;
  overflow-y: auto;
  padding-top: 16px;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 160px;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: rgba(0, 0, 0, 0.4);
  text-align: center;
  gap: 8px;

  .empty-icon {
    font-size: 40px;
    opacity: 0.4;
  }

  p {
    font-size: 15px;
    font-weight: 600;
    margin: 0;
  }

  span {
    font-size: 13px;
  }
}

.notes-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
</style>
